import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'green-middle-truncate',
	standalone: true,
	imports: [NgIf, MatTooltipModule],
	template: `
		<div
			class="flex items-center w-full min-w-0"
			(mouseenter)="checkTruncation()"
			[matTooltip]="text"
			[matTooltipDisabled]="!isTruncated">
			<span
				#startSpan
				class="truncate min-w-[20px] shrink"
				[textContent]="startText"></span>
			<span
				*ngIf="endText"
				class="shrink-0 text-right"
				[textContent]="endText"></span>
		</div>
	`
})
export class MiddleTruncateComponent {
	@Input() text: string = '';
	@Input() tailLength: number = 6;

	@ViewChild('startSpan') startSpan!: ElementRef<HTMLElement>;

	isTruncated = false;

	get startText(): string {
		if (!this.text) return '';
		if (this.text.length <= this.tailLength) return this.text;
		
		return this.text.slice(0, -this.tailLength);
	}

	get endText(): string {
		if (!this.text || this.text.length <= this.tailLength) return '';
		
		return this.text.slice(-this.tailLength);
	}

	checkTruncation() {
		if (this.startSpan) {
			const el = this.startSpan.nativeElement;
			this.isTruncated = el.scrollWidth > el.clientWidth;
		}
	}
}